import { type FC } from "react";

interface KnowRowProps {
  icon: FC<{ className?: string }>;
  label: string;
  value: string;
}

export const KnowRow: FC<KnowRowProps> = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-3 border-b border-primary bg-white p-4 last:border-b-0">
    <Icon className="h-4 w-4 shrink-0 text-secondary" />
    <div className="flex flex-1 items-center justify-between min-w-0">
      <span className="text-sm font-medium">{label}</span>
      <span className="text-sm text-secondary">{value}</span>
    </div>
  </div>
);
